import api from "../utils/api";

/** Services setup (roles -> linked template fields). Used by the event editor and Planner to keep linked fields in lock-step. */
export default class servicesCache {
	static config = null;
	static pending = null;

	static GetConfig = async (useCache = true) => {
		if (useCache && this.config) return this.config;
		if (!this.pending) {
			this.pending = api.getServicesConfig()
				.then(config => { this.config = config; return config; })
				.catch(err => { console.warn('Could not load services config', err); return null; })
				.finally(() => { this.pending = null; });
		}
		return this.pending;
	}

	static Set = (config) => { this.config = config; }
}
